import type { Delivery } from './incoming.ts';
import type { LineProgress, Request } from './requests.ts';
import type { Donation, People } from './schemas.ts';

// Donations' live topics (plan 2C Assumption 12).

/** Every donation and delivery change, settlement included: for donations.view_all. */
export const ALL_TOPIC = 'donations.all';

/** Active requests and their progress (Chunk 4): for donations.view_requests. */
export const REQUESTS_TOPIC = 'donations.requests';

/** "The boards changed": pages re-read them. For donations.view_requests. */
export const BOARDS_TOPIC = 'donations.boards';

/** The materials list changed: for donations.view_requests. */
export const MATERIALS_TOPIC = 'donations.materials';

/** A target's donations changed: pages read again. For donations.view_requests. */
export const TARGETS_TOPIC = 'donations.targets';

/** The personal topic's name, without its param. */
export const ME_TOPIC = 'donations.me';

/** One user's donations, confirmations and drafts, and what waits on them; only that user may subscribe. */
export function meTopic(userId: string): string {
  return `${ME_TOPIC}:${userId}`;
}

/** A donation changed. */
export interface DonationChange {
  type: 'donation';
  donation: Donation;
  people: People;
}

/** The boards changed: read them again. */
export interface BoardsChange {
  type: 'boards';
}

/** A request or its progress changed. On donations.requests only while it's Active (or just stopped being). */
export interface RequestChange {
  type: 'request';
  request: Request;
  progress: LineProgress[];
  people: People;
}

/** A request draft was withdrawn. */
export interface RequestRemoved {
  type: 'request_removed';
  id: string;
}

/** An expected delivery changed. */
export interface DeliveryChange {
  type: 'delivery';
  delivery: Delivery;
  people: People;
}
